module.exports = __webpack_public_path__ + "static/media/bankseta_logo.77e20447.jpg";